import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import _ from 'lodash';
import moment from 'moment';
import { Statistic } from 'semantic-ui-react';
import numeral from 'numeral';
import StatusBar from '../../containers/status-bar';
import hasUserInfo from '../../hocs/has-user-info';
import hasRESTClient from '../../hocs/has-rest-client';
import LaunchMetricsCampaignList from '../launch-metrics-campaign-list';

const getCampaignInfluencers = campaign => _.map(campaign.campaignDiscussions, 'name');

const getUniqueInfluencers = campaigns => {
  const influencers = _.flatMap(campaigns, getCampaignInfluencers);
  return _.uniq(influencers);
};
const formatNumber = (num, numFormat) => numeral(num).format(numFormat);


class LaunchMetricsDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingCampaigns: true,
      isLoading: true,
      isFailed: false,
      isLoaded: false,
      isTimeoutError: false,
      records: [],
      selectedMonth: moment().format('YYYY-MM'),
    };
  }

  componentDidMount = () => {
    this.requestData();
  }

  requestData = () => {
    const { restClient, userInfo } = this.props;
    const { userId, organisationId } = userInfo;
    const { selectedMonth } = this.state;

    this.setState({
      isLoaded: false,
      isFailed: false,
      isLoading: true,
    });

    const options = {
      organisationId,
      userId,
      filter: {
        monthName: selectedMonth,
      },
    };
    const queryParams = encodeURIComponent(JSON.stringify(options));
    restClient({
      method: 'get',
      url: `/campaigns/active/query?q=${queryParams}`,
      baseURL: process.env.REACT_APP_CAMPAIGNS_GET_URL,
    }).then(response => {
      const { data: { data: { data, results } } } = response;
      this.setState({
        records: data,
        isLoadingCampaigns: false,
        totalRecords: results,
        isLoaded: true,
        isFailed: false,
        isLoading: false,
      });
    }).catch(error => {
      this.setState({
        isLoadingCampaigns: false,
        isLoaded: true,
        isTimeoutError: error && _.includes(error.toString(), 'timeout'),
        isFailed: true,
        isLoading: false,
      });
    });

    restClient({
      method: 'get',
      url: `/influencers/active/query?q=${queryParams}`,
      baseURL: process.env.REACT_APP_CAMPAIGNS_GET_URL,
    }).then(response => {
      const { data: { data: { data, results } } } = response;
      console.log(results);
      const uniqueInfluencers = data.uniqInfluencers;
      const totalInfluencers = data.totalInfluencers;
      this.setState({
        uniqueInfluencers,
        totalInfluencers,
      });
    }).catch(error => {
      this.setState({
      });
    });
  }

  onMonthSelect = (event, { value }) => {
    const { isLoading } = this.state;
    if (isLoading) return;
    this.setState({
      selectedMonth: value,
    }, this.requestData);
  }
  render() {
    const { userInfo: { role } } = this.props;
    const {
      selectedMonth,
      uniqueInfluencers,
      totalInfluencers,
      isLoading,
      isLoaded,
      isFailed,
      records,
      isLoadingCampaigns,
      isTimeoutError,
    } = this.state;

    const dateHeader = new Date(selectedMonth).toLocaleString('en-US', { month: 'long', year: 'numeric' });
    return (
      <div className="page">
        <StatusBar />
        <div className="page-hero">
          <div style={{ height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h1>{dateHeader} Active Campaigns</h1>
            <div>
              <Statistic>
                <Statistic.Value>{ isLoading ? '...' : formatNumber(totalInfluencers, '0,0')}</Statistic.Value>
                <Statistic.Label>Total influencers</Statistic.Label>
              </Statistic>
              <Statistic>
                <Statistic.Value>{ isLoading ? '...' : formatNumber(uniqueInfluencers, '0,0')}</Statistic.Value>
                <Statistic.Label>Unique influencers</Statistic.Label>
              </Statistic>
            </div>
          </div>
        </div>
        <div className="page-content">
          {
            <LaunchMetricsCampaignList
              isLoading={isLoading}
              isLoaded={isLoaded}
              isFailed={isFailed}
              records={records}
              isLoadingCampaigns={isLoadingCampaigns}
              isTimeoutError={isTimeoutError}
              selectedMonth={selectedMonth}
              onMonthSelect={this.onMonthSelect}
            />
          }
        </div>
      </div>
    );
  }
}

LaunchMetricsDashboard.propTypes = {
  userInfo: PropTypes.object.isRequired,
  restClient: PropTypes.func.isRequired,

};
export default compose(
  hasUserInfo,
  hasRESTClient,
)(LaunchMetricsDashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/launch-metrics-dashboard/index.js
 **/